module.exports = __webpack_public_path__ + "img/1f943.10b31bc.svg";